module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/male_couple-161f7231f80ac0c93fb0fe304a334c05.svg";